import {MemberActionTypes, StudioActionTypes} from "../actions/types";
import {MemberAction, MemberState} from "../actions/session_member";

const initialState = {
    loading: false,
    fetched: false,
} as MemberState

export const memberReducer = (state: MemberState = initialState, action: MemberAction) => {
    switch (action.type) {
        case MemberActionTypes.MEMBER_READY:
            return {fetched: true, loading: false, member: action.payload}
        case MemberActionTypes.MEMBER_EMPTY:
            return initialState
        case MemberActionTypes.MEMBER_LOADING:
            return {loading: true, fetched: false}
        default:
            return state
    }
}